var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAccount = function SvgIconAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 22H1v-4a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v4Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 5.5,
    r: 4.5,
    stroke: "currentColor",
    strokeWidth: 2
  })));
};
export default SvgIconAccount;